import {Component, OnInit} from "@angular/core";
import {BaseComponent} from "../../../base.component";
import {LoggerService} from "../../../common/logger.service";
import {UserService} from "../../../common/user.service";
import {GqlShopSessionService} from "../../../../checkout/graphql/shop-session/gql-shop-session.service";
import {ShopSessionUtil} from "../shop-session-util";
import {forkJoin} from "rxjs";
import {AppConfigService} from "../../../config/app-config.service";

@Component({
    selector: 'ssd-tab-summary',
    templateUrl: './ssd-tab-summary.component.html',
    styleUrls: ['../shop-session-dashboard-tab.scss'],
    standalone: false
})
export class SsdTabSummaryComponent extends BaseComponent implements OnInit {

    countryTotals: any = [];
    loading: boolean = false;

    // secondsBack: string = "604800";
    secondsBack: string = "3600";

    constructor(
        loggerService: LoggerService,
        userService: UserService,
        private gqlShopSessionService: GqlShopSessionService,
        private appConfigService: AppConfigService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.getLocaleTotals();
    }

    getLocaleTotals() {
        this.loading = true;
        const dashboardTotalsFilter = { secondsBack: parseInt(this.secondsBack)};
        forkJoin([
            this.appConfigService.getAppConfig(),
            this.gqlShopSessionService.getShopSessionDashboardShare(dashboardTotalsFilter)
        ]).subscribe(([appConfig, shopSessionDashboard]) => {
            this.countryTotals = ShopSessionUtil.createCountryTotals(shopSessionDashboard.localeTotals, appConfig.allowedCountries);
            this.log.debug("countryTotals", this.countryTotals);
            this.log.debug("localeTotals", shopSessionDashboard.localeTotals);
            this.loading = false;
        });

    }
}
